import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.revisions;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const revisionsSelector = createSelector(
    selectFeature, 
    (state) => state.revisions
);